import * as React from "react";

function SvgGoogleCloudPlatform(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 171.1 137.7"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M108.608 37.896h5.2l14.9-14.9.7-6.3c-27.7-24.4-69.9-21.8-94.4 5.9-6.8 7.7-11.7 16.8-14.4 26.7 1.7-.7 3.5-.8 5.2-.3l29.7-4.9s1.5-2.5 2.3-2.4c13.2-14.5 35.5-16.2 50.8-3.9z"
        fill="#ea4335"
      />
      <path
        d="M149.908 49.396c-3.4-12.6-10.4-23.9-20.2-32.6l-20.9 20.9c8.8 7.2 13.8 18.1 13.6 29.4v3.7c10.3 0 18.6 8.3 18.6 18.6s-8.3 18.6-18.6 18.6h-37.2l-3.7 3.8v22.2l3.7 3.7h37.2c26.7.2 48.5-21.3 48.7-47.9.1-16.2-7.9-31.4-21.2-40.4z"
        fill="#4285f4"
      />
      <path
        d="M48.008 137.496h37.2v-29.7h-37.2c-2.7 0-5.3-.6-7.7-1.7l-5.2 1.6-15 14.9-1.3 5.2c8.5 6.3 18.7 9.7 29.2 9.7z"
        fill="#34a853"
      />
      <path
        d="M48.008 40.996c-26.7.2-48.2 21.9-48 48.6.1 14.9 7 28.9 18.9 38l21.5-21.5c-9.3-4.2-13.5-15.2-9.3-24.6s15.3-13.5 24.6-9.3c4.1 1.9 7.4 5.2 9.3 9.3l21.5-21.5c-9.1-12-23.4-19.1-38.5-19z"
        fill="#fbbc05"
      />
    </svg>
  );
}

export default React.forwardRef(SvgGoogleCloudPlatform);
